import { CheckCircle2, BellRing } from "lucide-react";
import { LogoMark, LogoWord } from "../components/Logo";
import Seo from "../components/Seo";

export default function Merci() {
  return (
    <div className="bg-[#0C0D0E] min-h-screen flex flex-col" data-testid="merci-page">
      <Seo title="Merci pour votre intérêt — STOCKBOX 8" noindex />
      <header className="border-b border-[#2E333D]/60 px-4 sm:px-6 lg:px-8 h-16 flex items-center">
        <a href="/" className="flex items-center gap-2.5" data-testid="merci-logo">
          <LogoMark size={30} />
          <LogoWord />
        </a>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 py-16 grain relative">
        <div className="spotlight absolute inset-0" />
        <div className="relative max-w-xl text-center">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-[#FFC700]/10 border border-[#FFC700]/40 flex items-center justify-center mb-8">
            <CheckCircle2 size={32} className="text-[#FFC700]" />
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-[#F9FAFB]" data-testid="merci-title">
            Merci pour votre intérêt !
          </h1>
          <p className="mt-6 text-gray-400 leading-relaxed">
            Votre avis nous aide à développer STOCKBOX 8 pour répondre aux besoins réels
            des professionnels.
          </p>
          <p className="mt-3 text-gray-400 leading-relaxed">
            Vous serez informé des prochaines étapes du projet. Un email de confirmation
            vient de vous être envoyé.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/#inscription" data-testid="merci-notify-button"
              className="inline-flex items-center justify-center gap-2 bg-[#FFC700] text-[#0C0D0E] font-bold text-sm px-8 py-4 rounded-full uppercase tracking-wide hover:bg-[#FFD83D] transition-colors">
              <BellRing size={17} /> Être informé du lancement
            </a>
          </div>
          <a href="/" className="mt-8 inline-block text-sm text-gray-500 hover:text-[#FFC700] transition-colors" data-testid="merci-back-link">
            ← Retour au site
          </a>
        </div>
      </main>
    </div>
  );
}
